/* ADDED */

// When the Cart Drawer updates, update other producty qty selectors

const parentElement = document.querySelector('cart-drawer');

// Also handle clicks in recommendations panel
parentElement.addEventListener('click', function(event) {
  // Handle quantity changes in recommendations
  if (event.target.closest('.cart-recommendations-container')) {
    const quantityControl = event.target.closest('.quantity');
    if (quantityControl && event.target.classList.contains('quantity__button')) {
      const inputElement = quantityControl.querySelector('input');
      const productID = inputElement.getAttribute('data-product-id');
      const qtyDirection = event.target.getAttribute('name');
      const recInputValue = parseInt(inputElement.value);

      // If rec input hit 0, directly remove from cart via key
      if (recInputValue === 0) {
        const recItem = event.target.closest('.cart-rec-item');
        if (recItem) {
          recItem.classList.remove('is--in-cart');
          const addBtn = recItem.querySelector('.cart-rec-item__add-to-cart');
          if (addBtn) {
            addBtn.classList.remove('hide');
            addBtn.classList.remove('loading');
            addBtn.removeAttribute('aria-disabled');
          }
          const qtyWrap = recItem.querySelector('.cart-rec-item__quantity');
          if (qtyWrap) qtyWrap.classList.add('hide');
          inputElement.value = 1;
        }

        const cartInput = document.querySelector(`cart-drawer .cart-item .quantity__input[data-product-id='${productID}']`);
        if (cartInput) {
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems) {
            cartDrawerItems.updateQuantity(cartInput.dataset.key, cartInput.dataset.index, 0);
          }
        }
        return;
      }

      const cartDrawerItem = document.querySelector(`cart-drawer .cart-item [data-product-id='${productID}']`);
      if (cartDrawerItem) {
        const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`);

        if (cartDrawerItemButton && !cartDrawerItemButton.disabled) {
          cartDrawerItemButton.click();

          // Update recommendation totals after cart updates
          setTimeout(() => {
            const cartDrawerElement = document.querySelector('cart-drawer');
            if (cartDrawerElement && cartDrawerElement.isRecommendationsView) {
              cartDrawerElement.updateRecommendationTotals();
            }
          }, 1000);
        }
      }
    }
  }
});

parentElement.addEventListener('click', function(event) {

  // Skip handler for rec panel clicks — handled above
  if (event.target.closest('.cart-recommendations-container')) return;

  const quantityParent = event.target.closest('.quantity');
  if (quantityParent) {
    const inputElement = quantityParent.querySelector('input');
    const productID = inputElement.getAttribute('data-product-id');
    const quantityValue = parseInt(inputElement.value);
    const maxQuantity = parseInt(inputElement.getAttribute('max'));

    console.log('Quantity changing to: ' + quantityValue + ' for Product ID: ' + productID);

    // disable this button to prevent hammering, renabled in cart.js
    const quantityButtons = document.querySelectorAll('.quantity__button');
    quantityButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = 0.25;
    });

    // Find any other inputs of the same product id and change its value
    const quantityInputs = document.querySelectorAll(`.quantity__input[data-product-id='${productID}']`);
    quantityInputs.forEach(function(quantityInput) {
        quantityInput.value = quantityValue;
        //console.log('Quantity changed to:', quantityValue);
    });

    if (quantityValue >= maxQuantity) {
      console.log('Max quantity reached for Product ID: ' + productID);
      console.log('Max quantity is: ' + maxQuantity);
      console.log('Current quantity is: ' + quantityValue);
      //console.log('quantityValue:', quantityValue, 'type:', typeof quantityValue);
      //console.log('maxQuantity:', maxQuantity, 'type:', typeof maxQuantity);

      // Keep the plus disabled so users dont keep trying
      quantityInputs.forEach(function(quantityInput) {
        quantityInput.parentElement.querySelector('button[name="plus"]').disabled = true;
        quantityInput.parentElement.querySelector('button[name="plus"]').style.opacity = 0.25;
        quantityInput.parentElement.querySelector('button[name="plus"]').setAttribute('limit-reached', 'true');
      });

      // wait 1 second and renable the buttons, as they wont otherwise
      setTimeout(() => {
        quantityButtons.forEach(button => {
          if (!button.hasAttribute('limit-reached')) {
            button.disabled = false;
            button.style.opacity = 1;
          }
        });
      }, 1000);

    } else {
      // remove the limit-reached attribute if it exists
      quantityInputs.forEach(function(quantityInput) {
        quantityInput.parentElement.querySelector('button[name="plus"]').removeAttribute('limit-reached');
      });
    }



    if (quantityValue == 0) { // If 0, act as if it was removed and reset the relevant buttons.
      
      /* DIRECT COPY FROM CartRemoveButton FUNCTION */

      // Find any boost product grid items of the same ID and reset.
      const boostProductItems = document.querySelectorAll(`.boost-pfs-filter-product-item[data-id='${productID}']`);
      boostProductItems.forEach(function(boostProductItem) { // Probably only every 1 shown, but lets just loop it
        boostProductItem.classList.remove("boost-pfs-added");
        boostProductItem.querySelector('.quantity__input').value = 1; // Reset incase user adds again
      });

      // Find any product page items of the same ID and reset.
      const productForm = document.querySelector(`.unero-single-product-detail product-form[data-id='${productID}']`);
      if (productForm) {
        const productQty = document.querySelector(`.unero-single-product-detail .product-form__input[data-id='${productID}']`);
        productForm.classList.remove("hide");
        productQty.classList.add("hide");
        productQty.querySelector('.quantity__input').value = 1; // Reset in case user adds again
      }

      const ppProductItems = document.querySelectorAll(`.pp-item[data-product-id='${productID}']`);

      ppProductItems.forEach((ppProductItem) => {
        ppProductItem.classList.remove("is--in-cart");

        const addToCartBtn = ppProductItem.querySelector('.pp-item__add-to-cart');
        addToCartBtn.classList.remove("hide");
        addToCartBtn.classList.add("removing");
        addToCartBtn.disabled = true;
        setTimeout(() => {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("removing");
        }, 3000);

        ppProductItem.querySelector('.pp-item__quantity').classList.add("hide");
        ppProductItem.querySelector('.quantity__input').value = 1; // Reset in case user adds again
        console.log(ppProductItem.querySelector('.quantity__input').value);
      });

      const recItems = document.querySelectorAll(`.cart-rec-item[data-product-id='${productID}']`);
      recItems.forEach((recItem) => {
        recItem.classList.remove('is--in-cart');
        const addBtn = recItem.querySelector('.cart-rec-item__add-to-cart');
        if (addBtn) addBtn.classList.remove('hide');
        const qtyWrap = recItem.querySelector('.cart-rec-item__quantity');
        if (qtyWrap) qtyWrap.classList.add('hide');
        const qtyInput = recItem.querySelector('.quantity__input');
        if (qtyInput) qtyInput.value = 1;
      });


    }

  }
});




// When a user clicks the QTY changer on product form, pass a click to the cart drawer element to handle the functionality.
// Ideal way to do this would be with section rendering, but out of scope at the moment.

const productForm = document.querySelector('.product-form__input quantity-input.non-cart');

if (productForm) {

  productForm.addEventListener('click', function(event) {


    const qtyParent = event.target.closest('.quantity');
    if (qtyParent) {
      const inputElement = qtyParent.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}

// Direct copy of above, but for pp page

const previouslyPurchasedGrid = document.querySelector('.pp__collections');

if (previouslyPurchasedGrid) {

  previouslyPurchasedGrid.addEventListener('click', function(event) {

    if (event.target.parentElement.classList.contains('quantity')) {

      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}


// Direct copy of above, but for product boost grid 
const productGrid = document.querySelector('.boost-pfs-filter-products');

if (productGrid) {

  productGrid.addEventListener('click', function(event) {

    if (event.target.parentElement.classList.contains('quantity')) {

      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}



document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  const referrer = document.referrer;

  if (referrer.includes('/cart') && cartDrawer) {
      cartDrawer.open();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.indexOf("#cart") > -1) {
    console.log("Opening Cart");

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }
});






/* ORIGINAL FROM DAWN */

// Recommendations tuning
const REC_FETCH_TIMEOUT = 3000;   // whole "get recommendations" step
const REC_RENDER_TIMEOUT = 3000;  // fetching the product cards
const REC_PP_TIMEOUT = 2000;      // previously-purchased step (worker + handle map); must be < REC_FETCH_TIMEOUT so the fallback can still render
const REC_CACHE_TTL = 300000;     // 5 min
const REC_HANDLE_MAP_TTL = 3600000; // 1 h
const REC_LIVE_HOSTS = ['partandparcel.com.au', 'www.partandparcel.com.au', 'part-and-parcel-au.myshopify.com'];
const REC_EMPTY = { handles: [], type: null };

function withTimeout(promise, ms, label = 'Operation') {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

// Run fn over items with at most `limit` in flight. Results keep input order.
async function mapWithConcurrency(items, limit, fn) {
  const results = new Array(items.length);
  let next = 0;
  const workers = Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (next < items.length) {
      const i = next++;
      results[i] = await fn(items[i], i);
    }
  });
  await Promise.all(workers);
  return results;
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this._boundClose = this.close.bind(this);
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this._boundClose);
    //this.setHeaderCartIconAccessibility();
    
    // Recommendations state
    this.recommendationsPromise = null;   // single in-flight/resolved promise, shared by preload + click
    this.recommendationsToken = null;     // cart token the promise belongs to
    this.isRecommendationsView = false;
    this.checkoutInterceptInFlight = false;
    this.renderGeneration = 0;
    
    // Set up event listeners for recommendations
    this.setupRecommendationsListeners();

    // The handle map is a slow Liquid render (~3s cold). Warm it once per
    // session for logged-in customers so the PP path is fast on click.
    const data = window.cartRecommendationsData;
    if (data && data.enabled && data.customerId) {
      setTimeout(() => this.fetchHandleMap(data.customerId).catch(() => {}), 1000);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    
    // Preload recommendations in background
    if (this.shouldShowRecommendations()) {
      this.preloadRecommendations();
    }
  }

  close() {
    this.classList.remove('active');
    this.classList.remove('show-recommendations');
    this.isRecommendationsView = false;
    this.checkoutInterceptInFlight = false;
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    document.body.classList.remove('modal-open');
    
    // Reset recommendations view when closing
    this.hideRecommendationsPanel();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    const wasShowingRecs = this.isRecommendationsView;
    const recsPanel = wasShowingRecs ? this.querySelector('.cart-drawer__recommendations-panel') : null;
    const recsPanelClone = recsPanel ? recsPanel.cloneNode(true) : null;

    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (wasShowingRecs && recsPanelClone) {
      const existingPanel = this.querySelector('.cart-drawer__recommendations-panel');
      if (existingPanel) {
        existingPanel.replaceWith(recsPanelClone);
      } else {
        const footer = this.querySelector('.drawer__footer');
        if (footer) footer.before(recsPanelClone);
      }
      this.classList.add('show-recommendations');
      this.isRecommendationsView = true;

      this.syncRecItemStates();
      this.updateRecommendationTotals();
    }

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (!this._boundClose) this._boundClose = this.close.bind(this);
      overlay.removeEventListener('click', this._boundClose);
      overlay.addEventListener('click', this._boundClose);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble',
        selector: '.cart-content'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // ============================================
  // RECOMMENDATIONS FUNCTIONALITY
  // ============================================

  setupRecommendationsListeners() {
    // Intercept checkout button clicks (capture phase, before the form submits)
    document.addEventListener('click', (e) => {
      const checkoutBtn = e.target.closest('#CartDrawer-Checkout');
      if (!checkoutBtn) return;

      // A click is already being handled (e.g. double-click): swallow it so the
      // native submit can't skip the recommendations step.
      if (this.checkoutInterceptInFlight) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      if (!this.isRecommendationsView && this.shouldShowRecommendations()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.handleCheckoutClick();
      }
    }, true);

    // Panel buttons — delegated to the cart-drawer element because cart
    // re-renders replace the panel nodes (and any listeners bound to them)
    this.addEventListener('click', (e) => {
      if (e.target.closest('#recommendations-back-btn')) {
        this.hideRecommendationsPanel();
      } else if (e.target.closest('#recommendations-checkout-btn')) {
        this.proceedToCheckout();
      } else if (e.target.closest('#recommendations-close-btn')) {
        this.close();
      }
    });
  }

  shouldShowRecommendations() {
    // Respect feature flag
    if (!window.cartRecommendationsData?.enabled) return false;

    // Don't show if cart is empty
    const cartItems = document.querySelectorAll('#CartDrawer .cart-item');
    if (cartItems.length === 0) return false;

    return true;
  }

  // Drawer open and panel showing. Used to decide whether an async result
  // should still render / auto-proceed.
  isPanelActive() {
    return this.isRecommendationsView && this.classList.contains('active');
  }

  async handleCheckoutClick() {
    if (this.checkoutInterceptInFlight) return;
    this.checkoutInterceptInFlight = true;
    console.log('=== Checkout intercepted, showing recommendations ===');

    try {
      const container = this.querySelector('#cart-recommendations-container');
      const alreadyRendered = container && container.children.length > 0;

      if (alreadyRendered) {
        console.log('=== Recommendations already rendered, just showing panel ===');
        this.showRecommendationsPanel({ loading: false });
        this.updateRecommendationTotals();
        return;
      }

      this.showRecommendationsPanel();

      // Same promise the preload started (or a cached result). Bounded so the
      // customer is never left on the spinner.
      const result = await withTimeout(this.getRecommendations(), REC_FETCH_TIMEOUT, 'Recommendations')
        .catch((error) => {
          console.error('=== Recommendations unavailable, proceeding to checkout ===', error);
          return REC_EMPTY;
        });

      // Customer pressed Back or closed the drawer while we waited.
      if (!this.isPanelActive()) {
        console.log('=== Panel no longer active, not rendering ===');
        return;
      }

      if (result.handles.length > 0) {
        await this.renderRecommendationProducts(result.handles, result.type);
      } else {
        console.log('=== No recommendations available, proceeding to checkout ===');
        this.proceedToCheckout();
      }
    } finally {
      this.checkoutInterceptInFlight = false;
    }
  }

  // Returns the one promise for "recommendations for the current cart".
  // Reused by the preload and the checkout click; re-created when the cart
  // token changes. Never rejects: errors resolve to REC_EMPTY (uncached).
  getRecommendations() {
    const token = this.getCartToken();
    if (this.recommendationsPromise && this.recommendationsToken === token) {
      return this.recommendationsPromise;
    }

    this.recommendationsToken = token;

    const cached = this.getRecommendationsFromCache();
    if (cached) {
      console.log('=== Found cached recommendations ===');
      this.recommendationsPromise = Promise.resolve({ handles: cached.handles, type: cached.type });
      return this.recommendationsPromise;
    }

    console.log('=== Fetching recommendations ===');
    const promise = this.fetchRecommendations()
      .then((result) => {
        const normalised = result && Array.isArray(result.handles) ? result : REC_EMPTY;
        if (normalised.partial) {
          if (this.recommendationsPromise === promise) this.recommendationsPromise = null;
        } else if (this.recommendationsToken === token) {
          this.cacheRecommendations(normalised);
        }
        return normalised;
      })
      .catch((error) => {
        console.error('=== Error fetching recommendations ===', error);
        // Allow a retry on the next call rather than pinning an error result
        if (this.recommendationsPromise === promise) this.recommendationsPromise = null;
        return REC_EMPTY;
      });

    this.recommendationsPromise = promise;
    return promise;
  }

  preloadRecommendations() {
    console.log('=== Preloading recommendations in background ===');
    this.getRecommendations().catch(() => {});
  }

  // PP (logged-in) and Shopify recs run in parallel so the total wait is the
  // slower of the two, not the sum. PP wins when it has >= 5 products.
  async fetchRecommendations() {
    const customerId = window.cartRecommendationsData && window.cartRecommendationsData.customerId;

    let ppFailed = false;
    const ppPromise = customerId
      ? this.fetchPreviouslyPurchased().catch((error) => {
          console.error('=== Error fetching previously purchased, falling back ===', error);
          ppFailed = true;
          return [];
        })
      : Promise.resolve([]);
    const shopifyPromise = this.fetchShopifyRecommendations().catch((error) => {
      console.error('=== Error fetching Shopify recommendations ===', error);
      return [];
    });

    const [ppResult, shopifyRecs] = await Promise.all([ppPromise, shopifyPromise]);

    if (ppResult.length >= 5) {
      console.log(`=== Using ${ppResult.length} previously purchased items ===`);
      return { handles: ppResult.slice(0, 10), type: 'previously-purchased' };
    }
    if (customerId) {
      console.log(`=== Only ${ppResult.length} previously purchased items, using Shopify recommendations ===`);
    }
    // partial: PP errored/timed out (e.g. cold handle map). Not cached, so the
    // next drawer open retries PP instead of pinning the fallback for 5 min.
    return { handles: shopifyRecs.slice(0, 10), type: 'you-may-like', partial: ppFailed };
  }

  // Worker returns product IDs (from D1 `bought_before`), ordered by purchase
  // count. IDs are mapped to handles with a theme-rendered map because the
  // Shopify AJAX product endpoint only accepts handles.
  async fetchPreviouslyPurchased() {
    const customerId = window.cartRecommendationsData.customerId;
    const url = new URL('https://pp-get-bought-before.chris-d45.workers.dev/');
    url.searchParams.set('customer_id', customerId);
    // Worker is CORS-locked to the live domains; dev/preview origins need the debug key.
    if (!REC_LIVE_HOSTS.includes(window.location.hostname)) {
      url.searchParams.set('debug', 'brightspire');
    }

    console.log('=== Calling previously purchased API ===', url.toString());

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REC_PP_TIMEOUT);

    try {
      // Worker call and handle map fetch run in parallel
      const [response, handleMap] = await Promise.all([
        fetch(url.toString(), { signal: controller.signal }),
        this.fetchHandleMap(customerId, controller.signal),
      ]);
      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const data = await response.json();
      console.log('=== Previously purchased data ===', data);

      if (!data.products || data.products.length === 0) {
        return [];
      }

      // Filter out products already in cart BY ID, before mapping to handles,
      // so the two lists can't go out of step.
      const cartProductIds = this.getCartProductIds();
      const candidateIds = data.products
        .map((id) => id.toString())
        .filter((id) => !cartProductIds.includes(id));

      // Map keeps worker order; IDs missing from the map (not in a PP aisle
      // collection, unavailable, or past the 50-per-collection Liquid cap) drop out.
      const handles = candidateIds.map((id) => handleMap[id]).filter(Boolean);
      console.log('=== Previously purchased handles ===', handles);
      return handles;
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error('=== Previously purchased API timeout ===');
      } else {
        console.error('=== Previously purchased API error ===', error);
      }
      throw error;
    }
  }

  // { "<product id>": "<handle>" } for available products in the
  // previously-purchased-aisles collections. Rendered by
  // templates/search.pp-handle-map.liquid, cached per customer for 1 h.
  async fetchHandleMap(customerId, signal) {
    const cacheKey = 'pp_handle_map';
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && cached.customerId === customerId && Date.now() - cached.timestamp < REC_HANDLE_MAP_TTL) {
        return cached.map;
      }
    } catch (error) {
      console.error('=== Error reading handle map cache ===', error);
    }

    const response = await fetch('/search?view=pp-handle-map', { signal });
    if (!response.ok) throw new Error(`Handle map returned ${response.status}`);
    const map = await response.json();

    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ customerId, timestamp: Date.now(), map }));
    } catch (error) {
      console.error('=== Error caching handle map ===', error);
    }
    return map;
  }

  async fetchShopifyRecommendations() {
    // Get first 5 cart items
    const cartProductIds = this.getCartProductIds().slice(0, 5);

    console.log('=== Cart product IDs for recommendations ===', cartProductIds);

    if (cartProductIds.length === 0) {
      return [];
    }

    const perProduct = await mapWithConcurrency(cartProductIds, 5, async (productId) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), REC_FETCH_TIMEOUT);
      try {
        const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=5`, {
          signal: controller.signal
        });
        if (!response.ok) return [];
        const data = await response.json();
        return (data.products || [])
          .filter((product) => product.available && product.handle)
          .map((product) => ({ handle: product.handle, id: product.id.toString() }));
      } catch (error) {
        console.error(`=== Error fetching recommendations for product ${productId} ===`, error);
        return [];
      } finally {
        clearTimeout(timeoutId);
      }
    });

    const allRecommendations = perProduct.flat();

    // Deduplicate and rank by frequency
    const handleCounts = {};
    allRecommendations.forEach(rec => {
      handleCounts[rec.handle] = (handleCounts[rec.handle] || 0) + 1;
    });

    // Sort by frequency, then remove duplicates
    const uniqueHandles = Object.keys(handleCounts).sort((a, b) => handleCounts[b] - handleCounts[a]);

    // Filter out products already in cart
    const cartIds = this.getCartProductIds();
    const filteredHandles = uniqueHandles.filter(handle => {
      const rec = allRecommendations.find(r => r.handle === handle);
      return !cartIds.includes(rec.id);
    });

    console.log('=== Shopify recommendations (filtered and ranked) ===', filteredHandles);
    return filteredHandles;
  }

  getCartProductIds() {
    const cartItems = document.querySelectorAll('#CartDrawer .cart-item');
    return Array.from(cartItems).map(item => item.getAttribute('data-product-id'));
  }

  async renderRecommendationProducts(handles, type) {
    console.log('=== Rendering recommendations ===', handles, type);
    const generation = ++this.renderGeneration;

    const loading = this.querySelector('.cart-drawer__recommendations-loading');
    const error = this.querySelector('.cart-drawer__recommendations-error');
    const empty = this.querySelector('.cart-drawer__recommendations-empty');
    if (error) error.style.display = 'none';
    if (empty) empty.style.display = 'none';

    if (!handles || handles.length === 0) {
      if (loading) loading.style.display = 'none';
      if (empty) empty.style.display = 'block';
      // Proceed to checkout after short delay
      setTimeout(() => { if (this.isPanelActive()) this.proceedToCheckout(); }, 2000);
      return;
    }

    // Fetch all cards in parallel with a shared deadline. Cards that miss the
    // deadline are dropped; whatever resolved is shown in ranked order.
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REC_RENDER_TIMEOUT);
    const results = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`/products/${handle}?view=cart-rec`, { signal: controller.signal });
        if (response.ok) {
          const html = await response.text();
          if (html && html.trim().length > 0) return html;
        }
      } catch (err) {
        console.error(`=== Error fetching product ${handle} ===`, err);
      }
      return null;
    }));
    clearTimeout(timeoutId);

    // A newer render started while we waited; let it win.
    if (generation !== this.renderGeneration) {
      console.log('=== Stale render discarded ===');
      return;
    }

    // Re-query: a cart re-render may have replaced the panel (cloneNode) in the meantime.
    const container = this.querySelector('#cart-recommendations-container');
    const freshLoading = this.querySelector('.cart-drawer__recommendations-loading');
    if (freshLoading) freshLoading.style.display = 'none';
    if (!container) return;

    const cards = results.filter(Boolean);
    if (cards.length === 0) {
      console.log('=== No recommendation cards rendered ===');
      if (this.isPanelActive()) this.proceedToCheckout();
      return;
    }

    container.innerHTML = '';
    cards.forEach((html) => container.insertAdjacentHTML('beforeend', html));
    container.dataset.recType = type || '';

    const heading = this.querySelector('#recommendations-heading');
    if (heading) heading.textContent = type === 'previously-purchased' ? 'Have you forgotten?' : 'You may also like';

    console.log('=== Recommendations rendered ===');

    this.syncRecItemStates();
    this.updateRecommendationTotals();
    if (this.isPanelActive()) this.trackRecommendationsViewed(type, container);
  }

  showRecommendationsPanel({ loading = true } = {}) {
    console.log('=== Showing recommendations panel ===');
    this.isRecommendationsView = true;

    const panel = this.querySelector('.cart-drawer__recommendations-panel');
    if (panel) {
      panel.style.display = 'flex';
    }

    const loadingEl = this.querySelector('.cart-drawer__recommendations-loading');
    if (loadingEl) loadingEl.style.display = loading ? 'flex' : 'none';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.classList.add('show-recommendations');
      });
    });
  }

  hideRecommendationsPanel() {
    console.log('=== Hiding recommendations panel ===');
    this.classList.remove('show-recommendations');
    this.isRecommendationsView = false;
    this.checkoutInterceptInFlight = false;

    // Reset panel after transition
    setTimeout(() => {
      const panel = this.querySelector('.cart-drawer__recommendations-panel');
      if (panel && !this.isRecommendationsView) {
        panel.style.display = 'none';
      }
    }, 300);
  }

  updateRecommendationTotals() {
    const doUpdate = () => {
      const checkoutTotal = this.querySelector('#recommendations-checkout-total');
      const mainCheckoutBtn = document.querySelector('#CartDrawer-Checkout span:last-child');
      if (mainCheckoutBtn && checkoutTotal) {
        checkoutTotal.textContent = mainCheckoutBtn.textContent.trim();
      }
    };
    doUpdate();
    setTimeout(doUpdate, 500);
  }

  proceedToCheckout() {
    console.log('=== Proceeding to checkout ===');
    // Submit the cart form to checkout
    const form = document.querySelector('#CartDrawer-Form');
    if (form) {
      // Create a hidden input for checkout
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '';
      form.appendChild(input);
      form.submit();
    } else {
      // Fallback to direct navigation
      window.location.href = '/checkout';
    }
  }

  syncRecItemStates() {
    const newCartItems = document.querySelectorAll('#CartDrawer .cart-item');
    const newCartProductIds = Array.from(newCartItems).map(item => item.getAttribute('data-product-id'));
    this.querySelectorAll('.cart-rec-item').forEach(recItem => {
      const pid = recItem.getAttribute('data-product-id');
      if (newCartProductIds.includes(pid)) {
        recItem.classList.add('is--in-cart');
        const addBtn = recItem.querySelector('.cart-rec-item__add-to-cart');
        if (addBtn) addBtn.classList.add('hide');
        const qtyWrap = recItem.querySelector('.cart-rec-item__quantity');
        if (qtyWrap) qtyWrap.classList.remove('hide');
        const cartItem = Array.from(newCartItems).find(ci => ci.getAttribute('data-product-id') === pid);
        if (cartItem) {
          const cartQty = cartItem.querySelector('.quantity__input');
          const recQty = recItem.querySelector('.quantity__input');
          if (cartQty && recQty) recQty.value = cartQty.value;
        }
      } else {
        recItem.classList.remove('is--in-cart');
        const addBtn = recItem.querySelector('.cart-rec-item__add-to-cart');
        if (addBtn) {
          addBtn.classList.remove('hide');
          addBtn.classList.remove('loading');
          addBtn.removeAttribute('aria-disabled');
        }
        const qtyWrap = recItem.querySelector('.cart-rec-item__quantity');
        if (qtyWrap) qtyWrap.classList.add('hide');
        const recQty = recItem.querySelector('.quantity__input');
        if (recQty) recQty.value = 1;
      }
    });
  }

  // ---- Klaviyo tracking ----

  getCartValue() {
    const total = document.querySelector('#CartDrawer-Checkout span:last-child');
    return total ? total.textContent.trim() : null;
  }

  klaviyoTrack(eventName, props) {
    if (typeof window._learnq === 'undefined') return;
    try {
      window._learnq.push(['track', eventName, props]);
      console.log('=== Klaviyo ===', eventName, props);
    } catch (error) {
      console.error('=== Klaviyo track failed ===', error);
    }
  }

  trackRecommendationsViewed(type, container) {
    const items = Array.from(container.querySelectorAll('.cart-rec-item'));
    this.klaviyoTrack('Viewed Cart Recommendations', {
      rec_type: type,
      product_count: items.length,
      product_ids: items.map((item) => item.getAttribute('data-product-id')),
      cart_value: this.getCartValue(),
    });
  }

  // Called from product-form.js after a successful add from the panel
  trackRecommendationAdded(recItem) {
    if (!recItem) return;
    const container = recItem.closest('#cart-recommendations-container');
    const items = container ? Array.from(container.querySelectorAll('.cart-rec-item')) : [];
    const nameEl = recItem.querySelector('.cart-rec-item__name');
    const priceEl = recItem.querySelector('.price--sale') || recItem.querySelector('.price');
    const variantInput = recItem.querySelector('input[name="id"]');
    const qtyInput = recItem.querySelector('input[name="quantity"]');
    const href = nameEl ? nameEl.getAttribute('href') || '' : '';

    this.klaviyoTrack('Added Cart Recommendation', {
      product_id: recItem.getAttribute('data-product-id'),
      handle: href.split('/products/')[1]?.split('?')[0] || null,
      title: nameEl ? nameEl.textContent.trim() : null,
      vendor: recItem.querySelector('.cart-rec-item__vendor')?.textContent.trim() || null,
      variant_id: variantInput ? variantInput.value : null,
      price: priceEl ? priceEl.textContent.trim() : null,
      quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
      rec_type: container ? container.dataset.recType || null : null,
      position: items.indexOf(recItem) + 1,
      cart_value: this.getCartValue(),
    });
  }

  // ---- Session cache ----

  cacheRecommendations(data) {
    if (!data || !data.handles) return;

    const cacheData = {
      handles: data.handles,
      type: data.type,
      timestamp: Date.now(),
      cartToken: this.getCartToken()
    };

    try {
      sessionStorage.setItem('cart_recommendations', JSON.stringify(cacheData));
      console.log('=== Recommendations cached ===');
    } catch (error) {
      console.error('=== Error caching recommendations ===', error);
    }
  }

  getRecommendationsFromCache() {
    try {
      const cached = sessionStorage.getItem('cart_recommendations');
      if (!cached) return null;

      const data = JSON.parse(cached);

      // Check if cache is expired
      const age = Date.now() - data.timestamp;
      if (age > REC_CACHE_TTL) {
        console.log('=== Cache expired ===');
        sessionStorage.removeItem('cart_recommendations');
        return null;
      }

      // Check if cart has changed
      const currentToken = this.getCartToken();
      if (data.cartToken !== currentToken) {
        console.log('=== Cart changed, cache invalid ===');
        sessionStorage.removeItem('cart_recommendations');
        return null;
      }

      return data;
    } catch (error) {
      console.error('=== Error reading cache ===', error);
      return null;
    }
  }

  // Keyed on the first 5 cart products (all fetchShopifyRecommendations
  // uses) plus the customer, so PP results don't leak across logins.
  getCartToken() {
    const ids = this.getCartProductIds().slice(0, 5).join(',');
    const customerId = window.cartRecommendationsData?.customerId || 'guest';
    return `${customerId}|${ids}`;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      } ,
      {
        id: 'icon-cart-contents',
        section: 'cart-icon-bubble',
        selector: '.cart-content'
      }
    ];
  }

  renderSections(parsedState) {
    const cartDrawer = document.querySelector('cart-drawer');
    const wasShowingRecs = cartDrawer && cartDrawer.isRecommendationsView;
    const recsPanel = wasShowingRecs ? cartDrawer.querySelector('.cart-drawer__recommendations-panel') : null;
    const recsPanelClone = recsPanel ? recsPanel.cloneNode(true) : null;

    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));

    if (wasShowingRecs && recsPanelClone && cartDrawer) {
      const existingPanel = cartDrawer.querySelector('.cart-drawer__recommendations-panel');
      if (existingPanel) {
        existingPanel.replaceWith(recsPanelClone);
      } else {
        const footer = cartDrawer.querySelector('.drawer__footer');
        if (footer) footer.before(recsPanelClone);
      }
      cartDrawer.classList.add('show-recommendations');
      cartDrawer.isRecommendationsView = true;

      cartDrawer.syncRecItemStates();
      cartDrawer.updateRecommendationTotals();
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
